module.exports = __webpack_public_path__ + "static/fc-28098541d1d3ba970d11abfa61d872bd.png";